/**
 * @tabler/icons-react v2.22.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBoneOff = createReactComponent("bone-off", "IconBoneOff", [
  [
    "path",
    {
      d: "M12.5 8.502l.38 -.38a3 3 0 1 1 5.12 -2.122a3 3 0 1 1 -2.12 5.122l-.372 .372m-2.008 2.008l-2.378 2.378a3 3 0 1 1 -5.117 2.297l0 -.177l-.176 0a3 3 0 1 1 2.298 -5.115l2.378 -2.378",
      key: "svg-0"
    }
  ],
  ["path", { d: "M3 3l18 18", key: "svg-1" }]
]);

export { IconBoneOff as default };
//# sourceMappingURL=IconBoneOff.js.map
